module.exports = __webpack_public_path__ + "static/3-bb9a9b5452f06e6202ed251099b0315f.png";